module.exports = __webpack_public_path__ + "static/media/03-quote-02-dolce-gabbana@2x.97be9012.jpg";